import { SubcategoryDetails } from "./subcat-details";

export class CategoryDetails {
    categoryHead: string;
    subcategoryDetails: SubcategoryDetails[]
    constructor(categoryHead: string, subcategoryDetails: SubcategoryDetails[]) {
        this.categoryHead = categoryHead;
        this.subcategoryDetails = subcategoryDetails
    }
}